import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { StarIcon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0f0a1e]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`} data-id="element-70">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-71">
        <div className="flex items-center justify-between h-16 md:h-20" data-id="element-72">
          {/* Logo / Product Name */}
          <a href="#" className="flex items-center gap-2" data-id="element-73">
            <StarIcon className="w-6 h-6 text-[#F5C842]" data-id="element-74" />
            <span className="text-white font-bold text-lg md:text-xl" data-id="element-75">
              Sistema Pro Cartas Natales
            </span>
          </a>

          {/* Navigation Links */}
          <div className="flex items-center gap-4 md:gap-8" data-id="element-76">
            <a href="#bonos" className="hidden sm:block text-white/80 hover:text-[#F5C842] transition-colors font-medium" data-id="element-77">
              Bonos
            </a>
            <a href="#testimonios" className="hidden sm:block text-white/80 hover:text-[#F5C842] transition-colors font-medium" data-id="element-78">
              Testimonios
            </a>
            <CTAButton href="#comprar" className="!py-2 !px-4 md:!py-3 md:!px-6 !text-sm md:!text-base" data-id="element-79">
              COMPRAR
            </CTAButton>
          </div>
        </div>
      </div>
    </nav>;
}